import { render } from "./Amount.vue?vue&type=template&id=f71b4a24&scoped=true"
import script from "./Amount.vue?vue&type=script&lang=js"
export * from "./Amount.vue?vue&type=script&lang=js"

import "./Amount.vue?vue&type=style&index=0&id=f71b4a24&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f71b4a24"]])

export default __exports__